<template>
    <div class="container" style="padding-top: 12px;">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.inventory_company_name" placeholder="请输入公司名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="platomCompanyName" label="公司名称"></el-table-column>
            <el-table-column prop="platomCompanyPerson" label="负责人"></el-table-column>
            <el-table-column prop="platomCompanyAdmin" label="超级管理员"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-tag style="cursor: pointer;" :type="scope.row.platomCompanyStatus == 1 ? 'success' : 'error'">{{
                    scope.row.platomCompanyStatus == 1 ? "启用" : "禁用" }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="platomCompanyMemo" label="备注"></el-table-column>
            <el-table-column label="创建时间" width="180">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="起始时间" width="180">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.platomCompanyStart / 1000) }}
                </template>
            </el-table-column>
            <el-table-column label="终止时间" width="180">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.platomCompanyEnd / 1000) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="210">
                <template slot-scope="scope">
                    <!-- <el-button @click="showDetail(scope.row)" type="text" size="small">查看</el-button> -->
                    <el-button @click="resetAdminPassword(scope.row.platomCompanyId)" type="text"
                        size="small">重置管理员密码</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="50%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="110px">
                    <el-form-item label="公司名称">
                        <el-input v-model="handleInfo.platomCompanyName"></el-input>
                    </el-form-item>
                    <el-form-item label="负责人">
                        <el-input v-model="handleInfo.platomCompanyPerson"></el-input>
                    </el-form-item>
                    <el-form-item label="超级管理员">
                        <el-input v-model="handleInfo.platomCompanyAdmin"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="handleInfo.platomCompanyStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="起始时间">
                        <el-date-picker type="date" v-model="handleInfo.platomCompanyStart" format="yyyy-MM-dd"
                            value-format="timestamp" placeholder="选择起始时间" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="终止时间">
                        <el-date-picker type="date" v-model="handleInfo.platomCompanyEnd" format="yyyy-MM-dd"
                            value-format="timestamp" placeholder="选择终止时间" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="handleInfo.platomCompanyMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import { doGet } from "@/api/api"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            customerId: "",
            isDetail: false,
        }
    },
    methods: {
        showDetail: function (row) {
            this.customerId = row.inventoryCustomerId;
            this.isDetail = true;
        },
        resetAdminPassword: async function (companyId) {
            this.$confirm('重置操作将会将超级管理员的密码设置为：123456', '重置密码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let resultObj = await doGet("/platomCompany/resetAdminPassword", {
                    companyId: companyId
                });
                this.showResult(resultObj);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>